import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const LabelWrapper = React.memo(
  ({
    className,
    formLabelClassName,
    containerClassName,
    labelText,
    children,
    errorTextClassName,
    errorLabel,
  }) => {
    return (
      <div
        className={`${styles.labelWrapper}${className ? ` ${className}` : ''}`}
      >
        <label
          className={`${styles.formLabel}${
            formLabelClassName ? ` ${formLabelClassName}` : ''
          }`}
        >
          {labelText}
        </label>
        <div className={containerClassName}>{children}</div>
        {errorLabel && (
          <span
            className={`${styles.labelWrapperErrorText}${
              errorTextClassName ? ` ${errorTextClassName}` : ''
            }`}
          >
            {errorLabel}
          </span>
        )}
      </div>
    );
  }
);

LabelWrapper.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  errorTextClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  formLabelClassName: PropTypes.string,
  labelText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.func,
  ]),
  errorLabel: PropTypes.string,
};

LabelWrapper.displayName = 'LabelWrapper';

export default LabelWrapper;
